import React from "react";
import './MissionVision.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import AboutBanner from "../Components/AboutBanner";
import mivission from "./assets/about.jpg";
import mimission from "./assets/about.jpg";

const MissionVision = () => {
    return (
        <>
            <div className="row">
                <div className="col-1 leftcol">
                    {/* <HomeLeft /> */}
                </div>
                <div className="col-10 middlecol">
                    <HomeSearchbar />
                    <AboutBanner />
                    <div className="row g-5 msnvsn">
                        <div className="col-lg-12">
                            <img src={mivission} alt="MI Vission" className="mivission" />
                            <h2>MI Vision</h2>
                            <hr className="about-line"></hr>
                            <p>Our vision is to be a globally recognized leader in the export of high-quality and affordable Japanese vehicles, empowering businesses and individuals across the Pacific region and beyond. By embracing the growing demand for reliable used automobiles, we aim to support sustainable practices, foster economic growth, and deliver unparalleled customer satisfaction, creating lasting value for our partners and communities worldwide.</p>
                        </div>
                        <div className="col-lg-12">
                            <img src={mimission} alt="MI Mission" className="mimission" />
                            <h2>MI MIssion</h2>
                            <hr className="about-line"></hr>
                            <p>Our mission is to lead the Japanese vehicle export industry by fostering a corporate culture rooted in honesty, integrity, and teamwork. With a multilingual team, we are committed to delivering exceptional customer satisfaction through passionate service and excellence in the used automobile industry. By building strong relationships with auction partners, we aim to ensure quality vehicles and empower mutual success for our customers worldwide.</p>
                        </div>
                    </div>
                </div>
                <div className="col-1 rightcol">
                    {/* <HomeRight /> */}
                </div>
            </div>

        </>
    );
};

export default MissionVision;